import React from 'react';

const DrilldownPage = () => {
    return <div />;
};

export default DrilldownPage;
